export default __webpack_public_path__ + "static/media/img_vision_05_m.17add4c8.png";